export default __webpack_public_path__ + "static/bg-superhuman-ai-bb61f189c058d779da9668c5b7853dc9.webp";